(ns frontend.view.components.timeline.entry.oppo-pass
  (:require
   [frontend.view.components.timeline.entry.declaration :as te]
   [frontend.view.components.timeline.entry.default-item :as default]
   [frontend.view.components.timeline.entry.utils :as utils]
   [clojure.string :as string]
   [common.entity :as entity]
   [frontend.state.current-session :as session]))

(defmethod te/timeline-entry-view :op.oppo/pass
  [{entry :entry}]
  (let [oppo (->> entry
                  :audit/target
                  (get @session/entities))
        reason (or (->> oppo
                        :oppo/pass-reason)
                   (->> oppo
                        :oppo/pass-reason-v2))
        reason (if (string? reason)
                 reason
                 (->> reason
                      (session/get-entity)
                      entity/display-string))
        comment-change (get-in entry [:audit/target-changes :oppo/status-comment])
        comment (when comment-change (:set comment-change))
        body-generator (fn [] [:p
                               (str reason
                                    (when (and comment
                                               (not (string/blank? comment)))
                                      (str " - '" comment "'")))])]
    [default/timeline-item-view entry utils/oppo-named-title-generator body-generator
     default/timestamp-generator]))
